import { TOKEN_KEY } from '@/constant/cache-key'
import { loadStorage, removeSessionStorage, removeStorage, saveStorage } from '@/utils/cache'

const CS_TOKEN_KEY = 'rockbang_console'

function isLogin() {
  return !!loadStorage(TOKEN_KEY, '')
}

function getToken() {
  return loadStorage(TOKEN_KEY, '')
}

function setToken(token: string) {
  saveStorage(TOKEN_KEY, token)
}

function clearToken() {
  removeStorage(TOKEN_KEY)
}

function clearCsToken() {
  removeStorage(CS_TOKEN_KEY)
}

function setCsToken(params: string) {
  saveStorage(CS_TOKEN_KEY, params)
}

function clearCustomerId() {
  removeSessionStorage('CUSTOMER_ID')
}

export {
  isLogin,
  getToken,
  setToken,
  clearToken,
  clearCsToken,
  setCsToken,
  clearCustomerId,
}
